export const getCookie = cookieName => {
  let name = cookieName + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return JSON.parse(c.substring(name.length, c.length));
    }
  }

  return "";
};

export const setCookie = (cookieName, cookieValue, expiryDays) => {
  const d = new Date();
  d.setTime(d.getTime() + expiryDays * 24 * 60 * 60 * 1000);
  const expires = "expires=" + d.toUTCString();
  if (process.env.NODE_ENV === "development") {
    document.cookie = cookieName + "=" + JSON.stringify(cookieValue) + ";" + expires + ";path=/";
  } else {
    document.cookie = cookieName + "=" + JSON.stringify(cookieValue) + ";" + expires + ";path=/;domain=.siterunner.com";
  }
};
